import { WriteTransaction } from "@workcanvas/reflect";
import { TimerConfigSchema } from "./schemas/timer";
import { authenticatedPut } from "../util/utils";

export const timerKey = "timer";

export async function putTimer(tx: WriteTransaction, config: TimerConfigSchema) {
  return authenticatedPut(tx, timerKey, config);
}
